// Mock data for Request Items

export interface RequestItem {
  id: number;
  workOrderId: number;
  itemType: string;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  totalPrice: number;
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'ORDERED' | 'RECEIVED';
  requestedBy: string;
  requestedDate: string;
  approvedBy?: string;
  approvedDate?: string;
  notes?: string;
}

export const requestItemTypes = [
  'Material',
  'Herramienta',
  'Equipo',
  'Servicio',
  'Repuesto',
  'Consumible'
];

export const requestItemUnits = [
  'Unidad',
  'Metro',
  'Metro cuadrado',
  'Metro cúbico',
  'Kilogramo',
  'Litro',
  'Hora',
  'Día',
  'Mes',
  'Año'
];

// Mock request items data
export const mockRequestItems: RequestItem[] = [
  {
    id: 1,
    workOrderId: 1,
    itemType: 'Material',
    description: 'Cemento Portland tipo I',
    quantity: 50,
    unit: 'Kilogramo',
    unitPrice: 25.50,
    totalPrice: 1275.00,
    status: 'APPROVED',
    requestedBy: 'Juan Pérez',
    requestedDate: '2024-01-15T10:30:00Z',
    approvedBy: 'María García',
    approvedDate: '2024-01-16T14:20:00Z',
    notes: 'Material de alta calidad requerido'
  },
  {
    id: 2,
    workOrderId: 1,
    itemType: 'Herramienta',
    description: 'Taladro percutor industrial',
    quantity: 2,
    unit: 'Unidad',
    unitPrice: 450.00,
    totalPrice: 900.00,
    status: 'ORDERED',
    requestedBy: 'Carlos López',
    requestedDate: '2024-01-17T09:15:00Z',
    approvedBy: 'María García',
    approvedDate: '2024-01-17T16:45:00Z'
  },
  {
    id: 3,
    workOrderId: 2,
    itemType: 'Material',
    description: 'Pintura acrílica blanca',
    quantity: 20,
    unit: 'Litro',
    unitPrice: 18.75,
    totalPrice: 375.00,
    status: 'PENDING',
    requestedBy: 'Ana Rodríguez',
    requestedDate: '2024-01-18T11:00:00Z',
    notes: 'Para acabado interior'
  },
  {
    id: 4,
    workOrderId: 2,
    itemType: 'Equipo',
    description: 'Compresor de aire portátil',
    quantity: 1,
    unit: 'Unidad',
    unitPrice: 750.00,
    totalPrice: 750.00,
    status: 'RECEIVED',
    requestedBy: 'Luis Martínez',
    requestedDate: '2024-01-12T08:30:00Z',
    approvedBy: 'Pedro Sánchez',
    approvedDate: '2024-01-13T10:15:00Z'
  },
  {
    id: 5,
    workOrderId: 3,
    itemType: 'Servicio',
    description: 'Consultoría técnica especializada',
    quantity: 40,
    unit: 'Hora',
    unitPrice: 85.00,
    totalPrice: 3400.00,
    status: 'APPROVED',
    requestedBy: 'Elena Vásquez',
    requestedDate: '2024-01-20T14:00:00Z',
    approvedBy: 'Roberto Torres',
    approvedDate: '2024-01-21T09:30:00Z'
  }
];

// Counter for generating new IDs
let nextId = Math.max(...mockRequestItems.map(item => item.id)) + 1;

// Mock API functions
export const getRequestItemsByWorkOrder = (workOrderId: number): RequestItem[] => {
  return mockRequestItems.filter(item => item.workOrderId === workOrderId);
};

export const getRequestItemById = (id: number): RequestItem | undefined => {
  return mockRequestItems.find(item => item.id === id);
};

export const createRequestItem = (newItem: Omit<RequestItem, 'id'>): RequestItem => {
  const requestItem: RequestItem = {
    ...newItem,
    id: nextId++,
    totalPrice: newItem.quantity * newItem.unitPrice
  };
  mockRequestItems.push(requestItem);
  return requestItem;
};

export const updateRequestItem = (id: number, updates: Partial<RequestItem>): RequestItem | null => {
  const index = mockRequestItems.findIndex(item => item.id === id);
  if (index === -1) return null;
  
  const updatedItem = {
    ...mockRequestItems[index],
    ...updates,
    totalPrice: (updates.quantity || mockRequestItems[index].quantity) * 
                (updates.unitPrice || mockRequestItems[index].unitPrice)
  };
  
  mockRequestItems[index] = updatedItem;
  return updatedItem;
};

export const deleteRequestItem = (id: number): boolean => {
  const index = mockRequestItems.findIndex(item => item.id === id);
  if (index === -1) return false;
  
  mockRequestItems.splice(index, 1);
  return true;
};

export const getRequestItemTypes = (): string[] => {
  return [...requestItemTypes];
};

export const getRequestItemUnits = (): string[] => {
  return [...requestItemUnits];
};
